var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoResult = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 190,
    viewBox: "0 0 160 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 178C124.183 178 160 142.183 160 98C160 53.8172 124.183 18 80 18C35.8172 18 0 53.8172 0 98C0 142.183 35.8172 178 80 178Z",
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6380_128602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.867 63.8672H34.1335C31.188 63.8672 28.8002 66.255 28.8002 69.2005V181.201C28.8002 184.146 31.188 186.534 34.1335 186.534H125.867C128.812 186.534 131.2 184.146 131.2 181.201V69.2005C131.2 66.255 128.812 63.8672 125.867 63.8672Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 79.8672H41.6C39.8327 79.8672 38.4 81.2999 38.4 83.0672C38.4 84.8345 39.8327 86.2672 41.6 86.2672H69.3334C71.1007 86.2672 72.5334 84.8345 72.5334 83.0672C72.5334 81.2999 71.1007 79.8672 69.3334 79.8672Z",
    fill: "#E0E0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5334 93.7344H41.6C39.8327 93.7344 38.4 95.1671 38.4 96.9344C38.4 98.7017 39.8327 100.134 41.6 100.134H88.5334C90.3007 100.134 91.7334 98.7017 91.7334 96.9344C91.7334 95.1671 90.3007 93.7344 88.5334 93.7344Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 108.668H41.6C39.8327 108.668 38.4 110.101 38.4 111.868C38.4 113.635 39.8327 115.068 41.6 115.068H69.3334C71.1007 115.068 72.5334 113.635 72.5334 111.868C72.5334 110.101 71.1007 108.668 69.3334 108.668Z",
    fill: "#E0E0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5334 122.535H41.6C39.8327 122.535 38.4 123.968 38.4 125.735C38.4 127.502 39.8327 128.935 41.6 128.935H88.5334C90.3007 128.935 91.7334 127.502 91.7334 125.735C91.7334 123.968 90.3007 122.535 88.5334 122.535Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3334 137.469H41.6C39.8327 137.469 38.4 138.901 38.4 140.669C38.4 142.436 39.8327 143.869 41.6 143.869H69.3334C71.1007 143.869 72.5334 142.436 72.5334 140.669C72.5334 138.901 71.1007 137.469 69.3334 137.469Z",
    fill: "#E0E0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5334 151.336H41.6C39.8327 151.336 38.4 152.769 38.4 154.536C38.4 156.303 39.8327 157.736 41.6 157.736H88.5334C90.3007 157.736 91.7334 156.303 91.7334 154.536C91.7334 152.769 90.3007 151.336 88.5334 151.336Z",
    fill: "#EBEBEB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6380_128602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.867 9.46484H34.1333C31.1877 9.46484 28.7999 11.8527 28.7999 14.7982V46.7982C28.7999 49.7437 31.1877 52.1315 34.1333 52.1315H125.867C128.812 52.1315 131.2 49.7437 131.2 46.7982V14.7982C131.2 11.8527 128.812 9.46484 125.867 9.46484Z",
    fill: "#E0E0E1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3331 21.1992H41.5998C39.8325 21.1992 38.3998 22.6319 38.3998 24.3992C38.3998 26.1665 39.8325 27.5992 41.5998 27.5992H69.3331C71.1004 27.5992 72.5331 26.1665 72.5331 24.3992C72.5331 22.6319 71.1004 21.1992 69.3331 21.1992Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5331 35.0664H41.5998C39.8325 35.0664 38.3998 36.4991 38.3998 38.2664C38.3998 40.0337 39.8325 41.4664 41.5998 41.4664H88.5331C90.3004 41.4664 91.7331 40.0337 91.7331 38.2664C91.7331 36.4991 90.3004 35.0664 88.5331 35.0664Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6380_128602",
    x: 22.8002,
    y: 54.8672,
    width: 114.4,
    height: 134.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6380_128602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6380_128602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6380_128602",
    x: 22.7999,
    y: 0.464844,
    width: 114.4,
    height: 54.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6380_128602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6380_128602",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon no-result.6e8cc5acfb4ae6edd37070ddaa41b8d2.svg";